import angular from 'angular';
import { localStorage } from '../utils';
import './modals/lines';
import './modals/line-flow-type-view';
import '../components/status';
import '../services/line';
import '../services/line-flow-type-organization';
import '../services/errors';
import '../services/notifications';
import '../services/globals';
import { get } from 'lodash';
import Roles from '../enums/roles';

const module = angular.module('whyline.controllers.lines', [
  'whyline.components.status',
  'whyline.services.line',
  'whyline.services.line-flow-type-organization',
  'whyline.services.errors',
  'whyline.services.notifications',
  'whyline.modals.line',
  'whyline.modals.line-flow-type-view',
  'whyline.services.globals',
]);

const LinesController = ($scope,
                         $window,
                         $timeout,
                         $translate,
                         $uibModal,
                         NotificationService,
                         LineService,
                         LineFlowTypeOrganizationService,
                         ErrorService,
                         dialog,
                         currentPlace,
                         SlaService
) => {
  /*@ngInject*/
  $scope.title = 'Lines';
  $scope.quantityOfItems = 8;
  $scope.lines = LineService.GetAll();

  LineFlowTypeOrganizationService.GetAllEnabledByOrganization(
    currentPlace.organizationId,
    false,
  ).then((lftoList) => {
    $scope.lineFlowTypeOrganizations = lftoList;
  });

  $scope.switch = LineService.Switch;
  //$scope.clear = LineService.Clear;
  $scope.showDisplayWarning = currentPlace.enterpriseType !== 'ba';
  $scope.plan = {};
  $scope.plan.maxLines = currentPlace.plan && currentPlace.plan.maxLines ? currentPlace.plan.maxLines : 5;

  const user = localStorage.get('user');
  const permissions = get(user, 'permissions', '');

  const rolesAllowed = [Roles.organizationAdmin, Roles.adminGeneral];
  const someRolAllowed = (permissions.map(permission => rolesAllowed.indexOf(permission.role.name) > -1)).some(Boolean);

  $scope.showEnableForAllChannels = someRolAllowed || get(user, 'sudo', false);


  $scope.clear = line => {
    let n = line.label || '';
    let clean_sure_text = $translate.instant('line_{name}_clean_sure').replace('{name}', n);
    let total_waiting_text = $translate.instant('total_waiting_{number}_text').replace('{number}', line.waitingPeople);

    dialog.confirm(`${clean_sure_text} ${total_waiting_text}`)
      .then(() => {
        LineService.Clear(line)
          .catch(err => {
            ErrorService.handler(err);
          });
      });
  };

  $scope.remove = (lineId, name) => {
    let n = name || '';
    dialog.confirm($translate.instant('line_{name}_remove_sure').replace('{name}', n))
      .then(() => {
        LineService.Remove(lineId)
          .then(() => {
            let name_tags = `<span class="bold">${name || ''}</span>`;
            NotificationService.Success($translate.instant('fila_{name}_remove_succ').replace('{name}', name_tags));
            if($scope.showDisplayWarning){
              NotificationService.Warning($translate.instant('Please remember to refresh your display for your changes to take effect'));
            }

            $scope.lines = LineService.GetAll();
          })
          .catch(err => {
            $scope.lines = LineService.GetAllFromServer();
            ErrorService.handler(err);
          });
      });
  };

  // Modal
  $scope.open = lineId => {
    $uibModal.open({
      templateUrl: '/templates/components/modals/lines-modal.html',
      size: 'lg',
      controller: 'LineModalController',
      resolve: {
        lineId: () => lineId,
        currentPlace,
      }
    }).result.then(()=>{
      if ($scope.showDisplayWarning) {
        NotificationService.Warning($translate.instant('Please remember to refresh your display for your changes to take effect'));
      }
    });
  };

  $scope.enabledForAllChannelsToggle = line => {
    const { _id } = line;
    const  enabledForAllChannels = get(line, 'configuration.enabledForAllChannels', false);
    const placeId = get(currentPlace, '_id', '');

    LineService.EnabledForAllChannelsToggle(placeId, _id, enabledForAllChannels);
  };

  SlaService.GetSlaById(currentPlace.configuration.agingSLA._id).then(sla => {
    $scope.sla = sla;
  });

  $scope.openSlaModal = (slaId) => {
    $uibModal.open({
      templateUrl: '/templates/components/modals/slas-modal.html',
      size: 'lg',
      controller: 'SlaModalController',
      resolve: {
        slaId: () => slaId,
      },
    });
  };

  $scope.getLineFlowTypeName = (lineFlowTypeId) => {
    if ($scope.lineFlowTypeOrganizations) {
      const lineFlowType = $scope.lineFlowTypeOrganizations.find(
        (lineFlowTypeOrganization) => lineFlowTypeOrganization._id.toString() === lineFlowTypeId,
      );
      return get(lineFlowType, 'name', '') || '';
    }
  };

  $scope.openLineFlowType = (lineFlowTypeOrganizationId) => {
    $uibModal.open({
      templateUrl: '/templates/components/modals/line-flow-type-view-modal.html',
      size: 'lg',
      controller: 'LineFlowTypeViewModalController',
      resolve: {
        lineFlowTypeOrganizationId: () => lineFlowTypeOrganizationId,
      },
    });
  };
};

module.exports = module.controller('LinesController', LinesController);
